import { render, staticRenderFns } from "./AddReservation1.vue?vue&type=template&id=18b1b1ec&scoped=true&"
import script from "./AddReservation1.vue?vue&type=script&lang=js&"
export * from "./AddReservation1.vue?vue&type=script&lang=js&"
import style0 from "./AddReservation1.vue?vue&type=style&index=0&id=18b1b1ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1b1ec",
  null
  
)

export default component.exports